import { Link } from "react-router-dom";
import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { CONTACT, BRANDS } from "../../data/site";
import { Logo } from "./Navbar";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-brand/30 bg-ink">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-4 lg:px-16 lg:py-20">
      <div>
        <Logo white className="h-28" />
        <p className="mt-6 text-sm leading-relaxed text-[#9AA6B2]">
          Greater Faridabad's trusted bathroom fittings showroom — Jaquar, Kohler, Hindware — with designer tiles from Kajaria, Somany, Nitco and more.
        </p>
      </div>

      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-bright">Explore</p>
        <ul className="mt-5 space-y-3 text-sm">
          {[
            ["Home", "/"],
            ["Bath Fittings", "/brands"],
            ["Pipes & RO", "/pipes-ro"],
            ["Tile Adhesives", "/tile-adhesives"],
            ["About Us", "/about"],
            ["Contact", "/contact"],
          ].map(([label, to]) => (
            <li key={to}>
              <Link
                to={to}
                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-[#9AA6B2] transition-colors hover:text-brand-bright"
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-bright">Flagship Brands</p>
        <ul className="mt-5 space-y-3 text-sm text-[#9AA6B2]">
          {BRANDS.map((b) => (
            <li key={b.id}>
              <Link to="/brands" data-testid={`footer-brand-${b.id}`} className="transition-colors hover:text-brand-bright">
                {b.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-bright">Visit Us</p>
        <ul className="mt-5 space-y-4 text-sm text-[#9AA6B2]">
          <li className="flex gap-3">
            <MapPin size={16} className="mt-0.5 shrink-0 text-brand-bright" />
            <span data-testid="footer-address">{CONTACT.address}</span>
          </li>
          <li className="flex gap-3">
            <Phone size={16} className="mt-0.5 shrink-0 text-brand-bright" />
            <a href={CONTACT.phoneHref} data-testid="footer-phone" className="transition-colors hover:text-brand-bright">
              {CONTACT.phoneDisplay} · {CONTACT.owner}
            </a>
          </li>
          <li className="flex gap-3">
            <Mail size={16} className="mt-0.5 shrink-0 text-brand-bright" />
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="break-all transition-colors hover:text-brand-bright">
              {CONTACT.email}
            </a>
          </li>
          <li className="flex gap-3">
            <Clock size={16} className="mt-0.5 shrink-0 text-brand-bright" />
            <span>{CONTACT.hours}</span>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 sm:px-8 md:flex-row lg:px-16">
        <p className="font-mono text-[11px] tracking-wider text-[#6B7684]">
          © {new Date().getFullYear()} Shri Radhey Krishna Bath and Tiles. All rights reserved.
        </p>
        <p className="font-mono text-[11px] tracking-wider text-[#6B7684]">
          Authorised Dealer · Jaquar · Kohler · Hindware · Kajaria · Somany
        </p>
      </div>
    </div>
  </footer>
);
